import * as React from 'react';

import { Styled } from './caption.styles';
import type { CaptionProps } from './caption.types';

export const Caption = React.forwardRef<HTMLParagraphElement, CaptionProps>(
  (
    {
      children,
      className,
      ellipsis,
      fontWeight = 'regular',
      lineHeight,
      noMargin,
      ...props
    },
    forwardedRef
  ) => {
    const fullText = typeof children === 'string' ? children : undefined;

    return (
      <Styled.Caption
        $ellipsis={ellipsis}
        $fontWeight={fontWeight}
        $lineHeight={lineHeight}
        $noMargin={noMargin}
        className={className}
        data-xds="Caption"
        ref={forwardedRef}
        title={ellipsis && fullText ? fullText : undefined}
        {...props}
      >
        {children}
      </Styled.Caption>
    );
  }
);

Caption.displayName = 'Caption';
